module.exports = __webpack_public_path__ + "img/rhinoceros.29404efd.png";